import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  useScrollTrigger,
  Box,
  Grid,
  Paper,
  Popper,
  Fade,
  ClickAwayListener,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  MenuItem,
  Collapse,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import productCatalog from "../utils/productCatalog"

const logo = "/assets/ABOUT US/Logo ACROE square.png"

function Navbar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openItems, setOpenItems] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMainItem, setSelectedMainItem] = useState(null);
  const [selectedSubItem, setSelectedSubItem] = useState(null);
  const open = Boolean(anchorEl);

  const location = useLocation();
  const isProductPage = location.pathname.includes('/product/');

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50 || isProductPage);
    };

    handleScroll(); // Set initial state
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isProductPage]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileItemClick = (itemName) => {
    if (openItems.includes(itemName)) {
      setOpenItems(openItems.filter(item => item !== itemName));
    } else {
      setOpenItems([...openItems, itemName]);
    }
  };

  const renderMobileMenuItem = (item, level = 0) => {
    const hasSubItems = item.subCategories && item.subCategories.length > 0;
    const isOpen = openItems.includes(item.label);

    return (
      <div key={item.label}>
        <ListItem
          button
          onClick={() => hasSubItems ? handleMobileItemClick(item.label) : handleProductClick(item)}
          sx={{
            pl: 2 + level * 2,
            color: '#000000',
          }}
        >
          <ListItemText 
            primary={item.label}
            sx={{
              '& .MuiListItemText-primary': {
                fontWeight: hasSubItems ? 600 : 400,
              }
            }}
          />
          {hasSubItems && (isOpen ? <ExpandLess /> : <ExpandMore />)}
        </ListItem>
        {hasSubItems && (
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.subCategories.map(subItem => renderMobileMenuItem(subItem, level + 1))}
            </List>
          </Collapse>
        )}
      </div>
    );
  };

  const drawer = (
    <Box
      sx={{
        backgroundColor: 'rgba(255, 248, 225, 0.97)',
        height: '100%',
        pt: 2
      }}
    >
      <List>
        {productCatalog.map(item => renderMobileMenuItem(item))}
      </List>
      <Box sx={{ p: 2 }}>
        <Button
          component={Link}
          to="/contact"
          variant="outlined"
          fullWidth
          sx={{
            color: '#FFD700',
            borderColor: '#FFD700',
            '&:hover': {
              borderColor: '#FFD700',
              backgroundColor: 'rgba(255, 215, 0, 0.1)',
            },
          }}
        >
          Contact Us
        </Button>
      </Box>
    </Box>
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const navigate = useNavigate();

  const handleProductClick = (item) => {
    if (!item.subCategories) {
      navigate(item.path);
      handleClose();
    }
  };

  const handleSubItemClick = (item) => {
    if (item.subCategories) {
      setSelectedSubItem(item);
    } else {
      handleProductClick(item);
    }
  };

  const handleMainItemClick = (item) => {
    if (item.subCategories) {
      setSelectedMainItem(item);
      setSelectedSubItem(null);
    } else {
      handleProductClick(item);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedMainItem(null);
    setSelectedSubItem(null);
  };

  return (
    <>
    <AppBar 
      position="fixed"
      sx={{
        background: isScrolled 
          ? 'rgba(0, 0, 0, 0.95)'
          : 'transparent',
        boxShadow: isScrolled ? '0 2px 20px rgba(255, 215, 0, 0.1)' : 'none',
        transition: 'all 0.3s ease-in-out',
        backdropFilter: isScrolled ? 'blur(10px)' : 'none',
      }}
    >
      <Container>
        <Toolbar>
          <Link to="/" style={{
            color: isScrolled ? '#FFD700' : '#FFD700',
            textDecoration: 'none',
            fontSize: '1.5rem',
            letterSpacing: '0.5px',
            flexGrow: 1,
            display: "flex",
            justifyContent: "flex-start"
          }}>
            <img
              alt={"Logo"}
              src={logo}
              style={{
                width: "150px",
                margin: "-45px -10px -50px -10px",

              }} />
          </Link>
          {/*<Typography*/}
          {/*  variant="h6"*/}
          {/*  component="div"*/}
          {/*  sx={{*/}
          {/*    flexGrow: 1,*/}
          {/*    display: 'flex',*/}
          {/*    justifyContent: 'flex-start',*/}
          {/*    fontWeight: 600,*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Link to="/" style={{*/}
          {/*    color: isScrolled ? '#FFD700' : '#FFD700',*/}
          {/*    textDecoration: 'none',*/}
          {/*    fontSize: '1.5rem',*/}
          {/*    letterSpacing: '0.5px',*/}
          {/*  }}>*/}
          {/*    ACROE*/}
          {/*  </Link>*/}
          {/*</Typography>*/}
          <Button 
            component={Link} 
            to="/about"
            sx={{
              color: isScrolled ? '#FFD700' : '#FFD700',
              mx: 1,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
              textTransform: 'none',
              fontSize: '1.05rem',
              letterSpacing: '0.5px',
            }}
          >
            About Us
          </Button>
          <Button
            onClick={handleClick}
            aria-controls={open ? 'mega-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            sx={{
              color: isScrolled ? '#FFD700' : '#FFD700',
              mx: 1,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
              textTransform: 'none',
              fontSize: '1.05rem',
              letterSpacing: '0.5px',
            }}
          >
            Products
          </Button>
          {/*<Button*/}
          {/*  onClick={() => navigate("/news")}*/}
          {/*  aria-controls={open ? 'mega-menu' : undefined}*/}
          {/*  aria-haspopup="true"*/}
          {/*  aria-expanded={open ? 'true' : undefined}*/}
          {/*  sx={{*/}
          {/*    color: isScrolled ? '#FFD700' : '#FFD700',*/}
          {/*    mx: 1,*/}
          {/*    '&:hover': {*/}
          {/*      backgroundColor: 'rgba(255, 255, 255, 0.1)',*/}
          {/*    },*/}
          {/*    textTransform: 'none',*/}
          {/*    fontSize: '1.05rem',*/}
          {/*    letterSpacing: '0.5px',*/}
          {/*  }}*/}
          {/*>*/}
          {/*  News*/}
          {/*</Button>*/}
          <Button 
            onClick={() => navigate("contact")}
            aria-controls={open ? 'mega-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            sx={{
              color: isScrolled ? '#FFD700' : '#FFD700',
              mx: 1,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
              textTransform: 'none',
              fontSize: '1.05rem',
              letterSpacing: '0.5px',
            }}
          >
            Contact Us
          </Button>

          <Popper
            id="mega-menu"
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            transition
            sx={{ width: '100%', zIndex: 1300 }}
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper
                  sx={{
                    mt: 1,
                    width: '100%',
                    borderRadius: '12px',
                    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.15)',
                    backdropFilter: 'blur(10px)',
                    backgroundColor: 'rgba(255, 248, 225, 0.97)',
                    border: '1px solid rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <ClickAwayListener onClickAway={handleClose}>
                    <Box sx={{ p: 2 }}>
                      <Grid container spacing={2}>
                        {/* Section 1: Main Menu */}
                        <Grid item xs={3}>

                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: 600,
                              mb: 2,
                              color: '#000000',
                              fontSize: '1.1rem',
                              letterSpacing: '0.5px',
                              borderBottom: '2px solid rgba(0, 0, 0, 0.2)',
                              paddingBottom: '8px',
                            }}>
                            Category
                          </Typography>
                          {productCatalog.map((item) => (
                            <Box
                              key={item.label}
                              onClick={() => handleMainItemClick(item)}
                              sx={{
                                p: 1.5,
                                minWidth: '100%',
                                borderRadius: '8px',
                                m: 0.5,
                                cursor: "pointer",
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                  bgcolor: 'rgba(0, 0, 0, 0.05)',
                                  transform: 'translateX(5px)',
                                },
                              }}
                            >
                              <Typography sx={{
                                fontSize: '0.95rem',
                                color: '#000000',
                                fontWeight: selectedMainItem === item ? 600 : 400,
                              }}>{item.label}</Typography>
                            </Box>
                          ))}
                        </Grid>

                        {/* Section 2: Sub Menu */}
                        <Grid item xs={3}>
                          {selectedMainItem && (
                            <>
                              <Typography 
                                variant="subtitle1" 
                                sx={{ 
                                  fontWeight: 600,
                                  mb: 2,
                                  color: '#000000',
                                  fontSize: '1.1rem',
                                  letterSpacing: '0.5px',
                                  borderBottom: '2px solid rgba(0, 0, 0, 0.2)',
                                  paddingBottom: '8px',
                                }}>
                                {selectedMainItem.label}
                              </Typography>
                              {selectedMainItem.subCategories.map((item) => (
                                <Box
                                  key={item.label}
                                  onClick={() => handleSubItemClick(item)}
                                  sx={{
                                    p: 1.5,
                                    minWidth: '100%',
                                    borderRadius: '8px',
                                    m: 0.5,
                                    cursor: "pointer",
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                      bgcolor: 'rgba(0, 0, 0, 0.05)',
                                      transform: 'translateX(5px)',
                                    },
                                  }}
                                >
                                  <Typography sx={{ 
                                  fontSize: '0.95rem',
                                  color: '#000000',
                                  fontWeight: selectedMainItem === item ? 600 : 400,
                                }}>{item.label}</Typography>
                                </Box>
                              ))}
                            </>
                          )}
                        </Grid>

                        {/* Section 3: Detail Menu */}
                        <Grid item xs={3}>
                          {selectedSubItem && (
                            <>
                              <Typography 
                                variant="subtitle1" 
                                sx={{ 
                                  fontWeight: 600,
                                  mb: 2,
                                  color: '#000000',
                                  fontSize: '1.1rem',
                                  letterSpacing: '0.5px',
                                  borderBottom: '2px solid rgba(0, 0, 0, 0.2)',
                                  paddingBottom: '8px',
                                }}>
                                {selectedSubItem.label}
                              </Typography>
                              {selectedSubItem.subCategories.map((item) => (
                                <MenuItem
                                  key={item.path}
                                  component={Link}
                                  to={item.path}
                                  onClick={handleClose}
                                  sx={{
                                    p: 1.5,
                                    minWidth: '100%',
                                    borderRadius: '8px',
                                    m: 0.5,
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                      bgcolor: 'rgba(0, 0, 0, 0.05)',
                                      transform: 'translateX(5px)',
                                    },
                                  }}
                                >
                                  <Typography sx={{ 
                                  fontSize: '0.95rem',
                                  color: '#000000',
                                  fontWeight: selectedMainItem === item ? 600 : 400,
                                }}>{item.label}</Typography>
                                </MenuItem>
                              ))}
                            </>
                          )}
                        </Grid>

                        {/* Section 4: Empty or Additional Info */}
                        {/*<Grid item xs={3}>*/}
                        {/*  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>*/}
                        {/*    Quick Actions*/}
                        {/*  </Typography>*/}
                        {/*  /!* Add quick actions or additional information here *!/*/}
                        {/*</Grid>*/}
                        </Grid>
                    </Box>
                  </ClickAwayListener>
                </Paper>
              </Fade>
            )}
          </Popper>
        </Toolbar>
      </Container>
    </AppBar>

      <Drawer
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 280,
            backgroundColor: 'rgba(255, 248, 225, 0.97)',
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
}

export default Navbar;
